// @flow
import jsPDF from "jspdf";
import "jspdf-autotable";

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16)
  ] : null;
}

export function convertImgToDataURLviaCanvas(url: string, callback: Function) {
  let img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function () {
    let canvas: HTMLCanvasElement = document.createElement("CANVAS");
    let ctx = canvas.getContext("2d");
    let dataURL;
    canvas.height = this.height;
    canvas.width = this.width;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL("image/jpeg");
    callback(dataURL);
    canvas = null;
  };
  img.src = url;
}

export function AdminPrint(tabelName: string, conference: *, count: number, primaryColor: string) {
  /* const columns = ["First Name", "Last Name", "Organisation / Company", "Email"];
  let rows = [];
  people && people.map((person, i) => {
    rows.push([person.first_name, person.last_name, person.organisation, person.email]);
  }); */

  let doc = new jsPDF("p", "pt");
  let elem = document.getElementById(tabelName);
  //let imgElements = document.querySelectorAll("#" + tabelName +" tbody img");
  let res = doc.autoTableHtmlToJson(elem);

  let images = [];
  let index = 0;
  const pageContent = function (data) {
    // HEADER
    const xOffset = function (text: string): number { return (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2); };
    doc.setFontSize(16);
    doc.setFontStyle("bold");
    doc.text(conference.display_name, xOffset(conference.display_name), 22);
    doc.setFontStyle("normal");
    doc.text(conference.sub_heading, xOffset(conference.sub_heading), 40);
    doc.text(count + " People Enrolled in Total", xOffset(count + " People Enrolled in Total"), 58);
    
    for (let i = 0; i < images.length; i++) {
      if(!images[i].isLoad){
        doc.addImage(images[i].url, "JPEG", images[i].x, images[i].y, 20, 20);
        images[i].isLoad = true;
      }
    }
  };
  doc.autoTable(res.columns, res.rows, {
    addPageContent: pageContent,
    margin: { top: 65 },
    showHeader: "everyPage",
    pageBreak: "auto",
    headerStyles: { fillColor: hexToRgb(primaryColor) },
    styles: { overflow: "linebreak", columnWidth: "auto", valign: "top" },
    columnStyles: { "4": { columnWidth: 50 } },
    tableWidth: "auto",
    drawRow: function (row, data) {
      let photoCount = row.cells[4].raw.childElementCount;
      let height = Math.max(Math.ceil(photoCount / 2), 1) * 30;
      row.height = height;
    },
    drawCell: function(cell, opts) {
      if (opts.column.dataKey === 4) {
        for(let j = 0; j < cell.raw.children.length; j++){
          images.push({
            url: cell.raw.children[j].currentSrc,
            x: cell.textPos.x + parseInt(j % 2) * 25,
            y: cell.textPos.y + parseInt(j / 2) * 25
          });
          index++;
        }
      }
    }
  });

  doc.save(conference.display_name + " - Delegates Enrolled.pdf");
};


// WEBPACK FOOTER //
// ./src/global/functions/AdminPrint.js